import { Controller } from "@hotwired/stimulus"

// Handles expand/collapse for inbox email rows
export default class extends Controller {
  static targets = ["content", "arrow"]

  toggle(event) {
    const isHidden = this.contentTarget.classList.contains("hidden")
    
    if (isHidden) {
      this.contentTarget.classList.remove("hidden")
      this.arrowTarget.classList.add("rotate-180")
    } else {
      this.contentTarget.classList.add("hidden")
      this.arrowTarget.classList.remove("rotate-180")
    }

    event.currentTarget.setAttribute("aria-expanded", isHidden.toString())
  }
}
